import CancerPage from "../components/CancerPage";

const stepsText = [
  "A PET (Positron Emission Tomography) scan: This scan can help determine the metabolic activity of the lesion and identify potential spread to other parts of the body (metastasis).",
  "Additional CT or MRI scans: A full series of CT or MRI with contrast to better assess the extent of the tumor, its relationship to surrounding structures, and to look for signs of metastatic disease in the lungs, liver, or lymph nodes.",
  "Blood tests: To check for overall health, kidney function, and markers that might indicate a paraneoplastic syndrome, which can be associated with kidney cancer.",
  "Histopathological Confirmation: A biopsy of the mass is typically performed to confirm the diagnosis of renal cell carcinoma and determine its specific subtype, which helps in treatment planning.",
];

export default function KidneyCancerPage() {
  return (
    <CancerPage
      cancerName="Kidney Cancer"
      scanType="X-Ray / CT Scan"
      analysisText="Based on the provided axial CT slice, a large, heterogeneous mass is noted in the left kidney, which is concerning for a renal cell carcinoma (RCC). The lesion appears to be well-defined but shows internal complexity. The right kidney appears unremarkable. As with any suspicious finding, histopathological confirmation via biopsy is the gold standard for definitive diagnosis. Further clinical correlation is advised to guide subsequent work-up and management."
      stepsTitle="Necessary Steps Following an Abnormal CT-Scan:"
      stepsText={stepsText}
    />
  );
}
